<template>
  <div class="enroll-exam-room-setting">
    <span class="title">
      请选择各考场人数限制
    </span>
    <span class="inputTitle">
      各考场考生人数最大值：
    </span>
    <el-input size="mini" type="number" min = "1" v-model="examRoomMaxNum" class="examRoomMaxNum"></el-input>
<!--    <span class="desc">-->
<!--      排考生成过程中，考场最大容量小于此值的，取该考场最大容量值-->
<!--    </span>-->
    <el-button type="primary" size="mini" class="btn" @click="arrangeSeat" :loading="loading">确认编排</el-button>
  </div>
</template>

<script>
export default {
  name: 'EnrollExamRoomSetting',
  props: {
    extraParams: Object
  },
  data () {
    return {
      examRoomMaxNum: null,
      loading: false
    }
  },
  created () {
    this.queryMaxNum()
  },
  activated () {
    this.queryMaxNum()
  },
  methods: {
    arrangeSeat () {
      if (!this.examRoomMaxNum || this.examRoomMaxNum.length <= 0) {
        this.$message.error('请先填写各考场考生人数最大值')
        return false
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/exam/room/arrange/seat',
        method: 'post',
        data: this.$qs.stringify({
          maxRoomCapacity: this.examRoomMaxNum
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.reloadGridData()
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    reloadGridData () {
      this.$parent.$parent.$parent.$parent.$parent.loadGridData()
    },
    queryMaxNum () {
      this.$ajax({
        url: '/workspace/manager/enrolling/exam/room/query/max/num',
        method: 'post',
        data: this.$qs.stringify({
          studentType: this.extraParams.studentType
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.examRoomMaxNum = response.data['examRoomMaxNum']
              break
            }
            default: {
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      })
    }
  }
}
</script>

<style lang="scss">
.enroll-exam-room-setting {
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  .title{
    font-size: 15px;
    white-space: nowrap;
  }
  .inputTitle{
    font-size: 12px;
    margin-left: 20px;
  }
  .examRoomMaxNum{
    width: 80px;
  }
  .desc{
    margin-left: 20px;
    font-size: 12px;
    color: rgb(245, 154, 35);
  }
  .btn{
    margin-left: 20px;
  }
}
</style>
